import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function ExitIntentPopup() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const shown = sessionStorage.getItem('exit_popup_shown');
    if (shown) return;

    const handler = (e) => {
      if (e.clientY < 10) {
        setShow(true);
        sessionStorage.setItem('exit_popup_shown', 'true');
        document.removeEventListener('mouseleave', handler);
      }
    };

    const timer = setTimeout(() => {
      document.addEventListener('mouseleave', handler);
    }, 5000);

    return () => {
      clearTimeout(timer);
      document.removeEventListener('mouseleave', handler);
    };
  }, []);

  if (!show) return null;

  return (
    <div className="popup-overlay" onClick={() => setShow(false)}>
      <div className="popup-content" onClick={e => e.stopPropagation()}>
        <button className="popup-close" onClick={() => setShow(false)}>&times;</button>
        <div style={{ fontSize: 48, marginBottom: 16 }}>&#9888;&#65039;</div>
        <h2 style={{ marginBottom: 12 }}>Aspetta! Non perdere questa opportunita</h2>
        <p style={{ color: '#6b7280', marginBottom: 20, fontSize: 15 }}>
          Ci sono <strong>oltre 75 incentivi</strong> disponibili per le imprese italiane.
          Scopri gratuitamente quali sono compatibili con la tua azienda.
        </p>
        <Link to="/register" className="btn btn-lg btn-green" onClick={() => setShow(false)}>
          Verifica Gratis i Tuoi Incentivi
        </Link>
        <p style={{ marginTop: 16, fontSize: 12, color: '#9ca3af' }}>
          Registrazione gratuita, nessun impegno
        </p>
      </div>
    </div>
  );
}
